import React from 'react';
import {AppBar, Box, CssBaseline, Menu, MenuItem, IconButton, Button,Toolbar,Dialog,
DialogTitle, DialogContent, DialogActions, Grid , Typography, Card, CardContent} from '@mui/material';
import { AccountCircle } from '@mui/icons-material';
import { useNavigate,  Link } from 'react-router-dom';
import LockResetIcon from '@mui/icons-material/LockReset';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import newLogo from '../../images/rcor_logo.png'
import FlexBetween from '../../components/FlexBetween';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../../styles/theme'
import HomeIcon from '@mui/icons-material/Home';
import HeaderBox from '../../components/HeaderBox';
import { DataGrid, GridColumnMenu } from '@mui/x-data-grid';
import MechanicAction from '../../components/Mechanic/MechanicAction';

const drawerWidth = 210;
const boxStyle = {
    root: {
      backgroundColor: 'white', 
      borderRadius: '5px',
      padding: 1,
    //   backgroundColor: '#e8f5e9'
    },
  };
const dataGridStyle = {
    root: {
      "& .MuiDataGrid-root": {
        borderRadius: '10px',
        backgroundColor: 'white',
        fontSize: '13px',
      },
      "& .MuiDataGrid-columnHeaders": {
        // color: '#005A9C',
        fontSize: '18px',
      }
    },
};

function CustomColumnMenu(props) {
    return (
      
      <GridColumnMenu
        {...props}
        slots={{
       // Hide `columnMenuColumnsItem`
        columnMenuColumnsItem: null,
        columnMenuSortItem: null,
        }}
      />
      
  );
  }
const columns = [
    { field: 'id', headerName: ' NO', editable: false, sortable: false, flex: 1, minWidth: 100 , },
    { field: 'SNNO', headerName: 'SN NO', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'SNDate', headerName: 'SN Date', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'Make', headerName: 'Make', editable: false, sortable: false, flex: 1 , minWidth: 100},
    { field: 'Model', headerName: 'Model', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'RegNO', headerName: 'Reg NO', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'Status', headerName: 'Status', editable: false, sortable: false, flex: 1 , minWidth: 100},
    { field: 'StartDate', headerName: 'Start Date', editable: false, sortable: false, flex: 1 , minWidth: 100},
    { field: 'EndDate', headerName: 'End Date', editable: false, sortable: false, flex: 1 , minWidth: 100},
    { field: 'TotalHours', headerName: 'Total Hours', editable: false, sortable: false, flex: 1 , minWidth: 100},
    { field: 'action', headerName: 'Actions', sortable: false, flex: 1, minWidth: 180, renderCell: (params) => {
        return (
                <MechanicAction title='Convert To Mechanic Order Update'  page='mechanic_update'/>
                );}
    }
    ];
    
     
    
const rows = [
    { id: '1', SNNO: '252', SNDate: '01-02-2023', Make: 'Audi', Model:'A5', RegNO:'CD123', Status:'Work In Progress', StartDate: '01-08-2023', EndDate:'10-08-2023', TotalHours:'' , action:''  },
    { id: '2', SNNO: '253', SNDate: '01-02-2023', Make: 'Bmw', Model:'C5', RegNO:'Tx258', Status:'Allocated', StartDate: '01-08-2023', EndDate:'03-08-2023', TotalHours:'' , action:''  },
    { id: '3', SNNO: '254', SNDate: '01-02-2023', Make: 'Ford', Model:'Fista', RegNO:'BQ012', Status:'Completed', StartDate: '05-08-2023', EndDate:'05-08-2023', TotalHours:'2.5' , action:''  },
    { id: '4', SNNO: '255', SNDate: '01-02-2023', Make: 'Audi', Model:'A5', RegNO:'Q1987', Status:'Allocated', StartDate: '01-08-2023', EndDate:'05-08-2023', TotalHours:'' , action:''  },
    { id: '5', SNNO: '256', SNDate: '01-02-2023', Make: 'Bmw', Model:'C5', RegNO:'SB012', Status:'Allocated', StartDate: '01-08-2023', EndDate:'06-08-2023', TotalHours:'' , action:''  },
    
    ];    

function Mechanic() {
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
    handleCloseMenu();
  };
  const handleClose = () => {
    setOpen(false);
    handleCloseMenu();
  };

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar
          component="nav"
          position="fixed"
          sx={{
            width: "100%",
            ml: { sm: `${drawerWidth}px` },
            backgroundColor: "#404040",
            height: "55px",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <FlexBetween>
              <IconButton
                sx={{ mb: "10px", mr: "5px" }}
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={() => navigate("/")}
                color="inherit"
              >
                <HomeIcon sx={{ fontSize: "25px" }} />
              </IconButton>
              <Link to="https://www.rcor.co/">
                <img src={newLogo} alt="logo" />
              </Link>
            </FlexBetween>
            <Toolbar>
              <Box>
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  color="inherit"
                >
                  <AccountCircle sx={{ fontSize: "20px", mr: "5px" }} />
                  <span style={{ fontSize: "14px" }}> User </span>
                </IconButton>
              </Box>
            </Toolbar>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorEl)}
              onClose={handleCloseMenu}
            >
              <MenuItem
                key="password"
                onClick={handleClickOpen}
                sx={{ fontSize: "14px" }}
              >
                <LockResetIcon sx={{ mr: "10px", fontSize: "18px" }} /> Change
                Password
              </MenuItem>
              <MenuItem
                key="logout"
                onClick={() => navigate("/")}
                sx={{ fontSize: "14px" }}
              >
                <PowerSettingsNewIcon sx={{ mr: "10px", fontSize: "18px" }} />{" "}
                Logout
              </MenuItem>
            </Menu>
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle
                id="alert-dialog-title"
                sx={{ fontSize: "15px", textAlign: "center" }}
              >
                Reset Password
              </DialogTitle>
              <DialogActions>
                <Button onClick={handleClose}>Close</Button>
              </DialogActions>
            </Dialog>
          </Box>
        </AppBar>

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            width: `calc(100% - ${drawerWidth}px)`,
            mt: "40px",
          }}
        >
          <Box mt={2}>
            <Grid container spacing={1}>
              <Grid item xs={12} mt={1}>
                <Grid item xs={12}>
                  <HeaderBox title="Mechanic Home Dashboard" />
                </Grid>
                <Box sx={boxStyle.root}>
                  <form>
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <Grid container spacing={1}>
                          <Grid item xs={12} sm={12} md={12}>
                            <Box sx={boxStyle.root}>
                              <Grid container spacing={1}>
                                <Grid item xs={12} sm={6} md={4}>
                                  <Card
                                    sx={{
                                      width: "100%",
                                      height: "80px",
                                      borderRadius: "10px",
                                    }}
                                  >
                                    <CardContent
                                      sx={{ p: "10px", bgcolor: "#e8f5e9" }}
                                    >
                                      <Typography
                                        sx={{ textAlign: "center" }}
                                        gutterBottom
                                      >
                                        Service Order Alloted
                                      </Typography>
                                      <Typography
                                        sx={{
                                          fontSize: "20px",
                                          fontWeight: "bold",
                                          textAlign: "center",
                                        }}
                                        component="div"
                                      >
                                        10
                                      </Typography>
                                    </CardContent>
                                  </Card>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                  <Card
                                    sx={{
                                      width: "100%",
                                      height: "80px",
                                      borderRadius: "10px",
                                    }}
                                  >
                                    <CardContent
                                      sx={{ p: "10px", bgcolor: "#e8f5e9" }}
                                    >
                                      <Typography
                                        sx={{ textAlign: "center" }}
                                        gutterBottom
                                      >
                                        Service Order Completed
                                      </Typography>
                                      <Typography
                                        sx={{
                                          fontSize: "20px",
                                          fontWeight: "bold",
                                          textAlign: "center",
                                        }}
                                        component="div"
                                      >
                                        8
                                      </Typography>
                                    </CardContent>
                                  </Card>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                  <Card
                                    sx={{
                                      width: "100%",
                                      height: "80px",
                                      borderRadius: "10px",
                                      bgcolor: "#e8f5e9",
                                    }}
                                  >
                                    <CardContent sx={{ p: "10px" }}>
                                      <Typography
                                        sx={{ textAlign: "center" }}
                                        gutterBottom
                                      >
                                        Work In Progress
                                      </Typography>
                                      <Typography
                                        sx={{
                                          fontSize: "20px",
                                          fontWeight: "bold",
                                          textAlign: "center",
                                        }}
                                        component="div"
                                      >
                                        2
                                      </Typography>
                                    </CardContent>
                                  </Card>
                                </Grid>
                              </Grid>
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </form>
                </Box>
              </Grid>
              <Grid item xs={12} mt={1}>
          <HeaderBox title="Allotted Job Card List" />
          <Grid item xs={12}>
            <Box sx={dataGridStyle.root}>
              <DataGrid
                columnHeaderHeight={35}
                rowHeight={35}
                rows={rows}
                columns={columns}
                getRowId={(row) => row.id}
                initialState={{
                  pagination: { paginationModel: { pageSize: 10 } },
                }}
                pageSizeOptions={[10]}
                slots={{ columnMenu: CustomColumnMenu }}
                disableRowSelectionOnClick
              />
            </Box>
          </Grid>
        </Grid>
            </Grid>
          </Box>
        </Box>
        
      </Box>
    </ThemeProvider>
  );
}


export default Mechanic;